
const ExportAsSegment = (canvas, x, width) => {
	const export_canvas = document.createElement('canvas')
	export_canvas.height = canvas.height;
	export_canvas.width = width

	export_canvas.getContext('2d').drawImage(canvas, -x, 0)

	return export_canvas.toDataURL('image/png')
}

const ExportThreeSegments = (canvas) => {
	return [
		{
			name : 'diagram-segment-0',
			data : ExportAsSegment(canvas, 0, canvas.width / 3)
		},
		{
			name : 'diagram-segment-1',
			data : ExportAsSegment(canvas, canvas.width / 3, canvas.width / 3)
		},
		{
			name : 'diagram-segment-2',
			data : ExportAsSegment(canvas, canvas.width * 2 / 3, canvas.width / 3)
		},
	]
}

export { ExportAsSegment, ExportThreeSegments }
